import { Component, OnInit, ViewEncapsulation} from '@angular/core';


@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class StepComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

}



// WEBPACK FOOTER //
// ./src/app/features/step/step.component.ts